// Lifts the boot sheet from index.html once the app has rendered and Archivo is in,
// so the hero lettering plays once, in its real face, instead of under the loader.
const SAMPLE = 'Od architektury, aż po produkcję. ĄĘŁŃÓŚŹŻ From architecture';
const MAX_WAIT_MS = 2000;

async function fontsLoaded() {
	if (!('fonts' in document)) return;
	await Promise.all(['400 1rem Archivo', '700 1rem Archivo'].map(font => document.fonts.load(font, SAMPLE)));
}

export function liftBootSheet() {
	const timeout = new Promise<void>(resolve => window.setTimeout(resolve, MAX_WAIT_MS));
	Promise.race([fontsLoaded().catch(() => undefined), timeout]).then(() => {
		// Two frames: the first commits React's DOM, the second lets layout settle before motion starts.
		requestAnimationFrame(() =>
			requestAnimationFrame(() => {
				document.documentElement.classList.add('is-ready');
				const boot = document.getElementById('boot');
				if (!boot) return;
				boot.classList.add('is-gone');
				window.setTimeout(() => boot.remove(), 400);
			})
		);
	});
}
